export * from './routes'
export const DAYS_BEFORE_REVERIFICATION_WARNING_REMINDER = 14
export const DAYS_BEFORE_REVERIFICATION_URGENT_REMINDER = 3
